var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhisiotherapyPana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.06,
    y: 36.68,
    width: 80.65,
    height: 84.07,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.6,
    y: 36.68,
    width: 80.65,
    height: 84.07,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.27,120.78h-80.7V36.66h80.7Zm-80.65,0h80.6v-84h-80.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.44,
    y: 47.98,
    width: 58.97,
    height: 61.47,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.44,109.86a9,9,0,0,1-1.45,1.69c-1,1-2.27,2.34-3.75,3.8s-2.85,2.77-3.85,3.69a9.82,9.82,0,0,1-1.71,1.42,9.86,9.86,0,0,1,1.45-1.69c.94-1,2.27-2.34,3.75-3.8s2.86-2.77,3.86-3.7A9.61,9.61,0,0,1,218.44,109.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.41,109.71a9.43,9.43,0,0,1,1.69,1.45c1,1,2.34,2.27,3.8,3.75s2.76,2.85,3.69,3.86a9.59,9.59,0,0,1,1.42,1.7,9.43,9.43,0,0,1-1.69-1.45c-1-.94-2.34-2.27-3.81-3.75s-2.77-2.86-3.69-3.86A9.07,9.07,0,0,1,277.41,109.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.25,48.15a9,9,0,0,1,1.45-1.69c.94-1,2.27-2.34,3.75-3.8s2.85-2.77,3.85-3.69A9.4,9.4,0,0,1,288,37.55a9.62,9.62,0,0,1-1.45,1.68c-.94,1-2.27,2.35-3.76,3.81s-2.85,2.77-3.86,3.7A9.81,9.81,0,0,1,277.25,48.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.28,48.3a8.9,8.9,0,0,1-1.69-1.46c-1-.94-2.34-2.26-3.8-3.74s-2.77-2.85-3.69-3.86a9.59,9.59,0,0,1-1.42-1.7A9.3,9.3,0,0,1,209.37,39c1,.94,2.34,2.27,3.8,3.75s2.77,2.86,3.7,3.86A9.61,9.61,0,0,1,218.28,48.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.25,109.45a1.71,1.71,0,0,1,0-.3c0-.21,0-.49,0-.85,0-.78,0-1.88,0-3.32,0-2.91,0-7.15-.06-12.53,0-10.77-.06-26.1-.11-44.47l.23.23-58.8,0h0l.26-.27c0,22.57,0,43.67,0,61.47l-.23-.22,42.58.11,12,.06,3.16,0H277l-.8,0-3.12,0-11.91.06-42.72.12h-.22v-.23c0-17.8,0-38.9,0-61.47v-.26h.27l58.8,0h.22V48c0,18.43-.08,33.81-.11,44.62,0,5.35-.05,9.57-.06,12.47,0,1.42,0,2.52,0,3.28,0,.35,0,.63,0,.83S277.25,109.46,277.25,109.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.09,
    y: 68.88,
    width: 19.68,
    height: 19.68,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.11,
    y: 408.14,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.78 138.36 168.78 204.99 73.09 204.99 69.64 138.83 168.78 138.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.48,
    y: 123.99,
    width: 66.02,
    height: 95.69,
    transform: "translate(-54.35 289.32) rotate(-90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,205.3H69.19V138.38h96.59Zm-95.69-.91h94.79V139.28H70.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 147.03,
    width: 74.96,
    height: 49.61,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,147h-.37l-1.07,0-4.12,0-15.44.06-54,.11.22-.22c0,15.16,0,32,0,49.61h0l-.24-.24,75,.05-.19.19c0-15.1.07-27.48.1-36.1,0-4.31,0-7.68.05-10,0-1.15,0-2,0-2.63s0-.91,0-.91,0,.29,0,.87,0,1.47,0,2.59c0,2.3,0,5.65.05,9.94,0,8.65.05,21.07.1,36.22v.18H155l-75,0h-.23v-.23h0c0-17.65,0-34.45,0-49.61v-.22H80l54.11.11,15.4.06,4.07,0H155Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.64,138.64a8.1,8.1,0,0,1,1.65,1.07c1,.71,2.31,1.71,3.75,2.86s2.7,2.24,3.59,3.06A7.18,7.18,0,0,1,80,147c-.08.1-2.39-1.8-5.26-4.09A52.51,52.51,0,0,1,69.64,138.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.33,138.83a47.1,47.1,0,0,1-5,4.29A47.86,47.86,0,0,1,155,147a46.41,46.41,0,0,1,5-4.28A46.23,46.23,0,0,1,165.33,138.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.26,204.86l-10.67-8.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,196.21a50.81,50.81,0,0,1,5.48,4.14,50.54,50.54,0,0,1,5.19,4.51,49.21,49.21,0,0,1-5.49-4.14A49.71,49.71,0,0,1,154.59,196.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.64,204.85a46.07,46.07,0,0,1,5-4.24,47.3,47.3,0,0,1,5.28-3.88,44.2,44.2,0,0,1-5,4.25A46.38,46.38,0,0,1,69.64,204.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.5,
    y: 147.21,
    width: 16.61,
    height: 47.17,
    transform: "translate(-51.99 289.6) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.19,
    y: 33.97,
    width: 6.35,
    height: 136.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.02,
    y: 35.03,
    width: 91.2,
    height: 135.75,
    rx: 0.09,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.19,171.83H363.05a.09.09,0,0,1-.09-.09V34.07a.09.09,0,0,1,.09-.1h93.14a.09.09,0,0,1,.09.1V171.74A.09.09,0,0,1,456.19,171.83Zm-91-2.11h88.9a.09.09,0,0,0,.09-.09V36.18a.09.09,0,0,0-.09-.09h-88.9a.1.1,0,0,0-.1.09V169.63A.1.1,0,0,0,365.17,169.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.2,
    y: 43.4,
    width: 73,
    height: 118.91,
    rx: 0.09,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.13,
    y: 77.11,
    width: 40.99,
    height: 48.04,
    rx: 0.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.87,119.28c.05.15-2,1-5.82.59a14.2,14.2,0,0,1-6.54-2.62,13.23,13.23,0,0,1-5.08-8,11.49,11.49,0,0,1,3.88-10.93,10.32,10.32,0,0,1,2.95-1.73,7.82,7.82,0,0,1,3.69-.42,6.42,6.42,0,0,1,3.68,1.61,4.81,4.81,0,0,1,1.46,4.29,7,7,0,0,1-2,3.69A13.44,13.44,0,0,1,420,108a17,17,0,0,1-7.37,2.11,14.73,14.73,0,0,1-7.85-1.79,14.34,14.34,0,0,1-5.78-6A12.22,12.22,0,0,1,398,94a12.46,12.46,0,0,1,4.42-6.91,11,11,0,0,1,3.7-1.87,9.32,9.32,0,0,1,4.17-.13A6.8,6.8,0,0,1,414,87.21a6.31,6.31,0,0,1,1.49,4.05,7.74,7.74,0,0,1-1,3.85,10.29,10.29,0,0,1-2.34,2.81,15.75,15.75,0,0,1-5.81,3.09,15,15,0,0,1-6.1.47,12.49,12.49,0,0,1-5.32-2,11.5,11.5,0,0,1-5.08-8,9.74,9.74,0,0,1,1.88-6.9,8.38,8.38,0,0,1,3.48-2.78c1-.36,1.51-.35,1.53-.26s-.43.35-1.21.86a9.1,9.1,0,0,0-2.71,2.91,8.57,8.57,0,0,0-1.1,5.89,9.6,9.6,0,0,0,4.51,6.32,11.1,11.1,0,0,0,9.31.89,13,13,0,0,0,4.66-2.64,5.7,5.7,0,0,0,2.18-4.36,3.13,3.13,0,0,0-2.81-3.1,6.06,6.06,0,0,0-2.67.12,7.7,7.7,0,0,0-2.53,1.33,9.2,9.2,0,0,0-3.19,5.08,8.83,8.83,0,0,0,.78,6.09,11.09,11.09,0,0,0,4.41,4.59,11.45,11.45,0,0,0,6.07,1.41,14,14,0,0,0,6-1.63,10.84,10.84,0,0,0,2.38-1.68,4,4,0,0,0,1.2-2,1.74,1.74,0,0,0-.48-1.59,3.66,3.66,0,0,0-2-.87,5,5,0,0,0-2.32.2,7.53,7.53,0,0,0-2.17,1.19,9,9,0,0,0-3.3,8.36,11.53,11.53,0,0,0,3.91,6.91,13.82,13.82,0,0,0,5.61,2.81C424.76,119.38,426.84,119,426.87,119.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.48,
    y: 223.85,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.56,250.27a1,1,0,0,1,0-.23v-.66c0-.61,0-1.45,0-2.53,0-2.23-.05-5.42-.08-9.45l.15.15-48.65.1c.11-.11-.25.25.24-.25h0v12.85l-.24-.24,34.67.11,10.23.07,2.77,0,.72,0h.26l-.23,0h-.69l-2.71,0-10.18.07-34.84.11h-.25v-13.1h0l.25-.25,48.65.1h.15v.15c0,4.07-.06,7.29-.08,9.54,0,1.06,0,1.9,0,2.49,0,.26,0,.47,0,.64A1.23,1.23,0,0,1,434.56,250.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.18,170.68a2.07,2.07,0,0,1,0-.23c0-.17,0-.39,0-.66,0-.61,0-1.45,0-2.53,0-2.23,0-5.42-.08-9.45l.15.15-48.65.1.25-.25h0v3.27c0,1.09,0,2.18,0,3.25v6.33l-.24-.24,34.67.11,10.23.07,2.77,0,.72,0h.26s-.07,0-.22,0h-.7l-2.71,0-10.18.06-34.84.11h-.24v-.25q0-3.1,0-6.33v-6.52h0l.25-.25,48.65.1h.15v.15c0,4.07-.06,7.29-.08,9.53,0,1.07,0,1.91,0,2.5v.64C254.19,170.62,254.19,170.69,254.18,170.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.78,157.81a1.22,1.22,0,0,1,0-.24c0-.19,0-.41,0-.69,0-.63,0-1.49,0-2.58,0-2.25-.06-5.44-.1-9.36l.18.18-29.23.07c-.23.22.3-.3.24-.25h0v6.61c0,2.15,0,4.24,0,6.24l-.23-.23,20.91.11,6.09.06,1.64,0,.59,0a3.28,3.28,0,0,1-.53,0l-1.6,0-6,.07-21.07.11h-.24v-.24c0-2,0-4.09,0-6.24V145h0l.25-.25,29.23.07H261v.18c0,4-.08,7.19-.1,9.47,0,1.07,0,1.92,0,2.54S260.79,157.82,260.78,157.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.25,59.11a1,1,0,0,1,0-.23l0-.66c0-.61,0-1.45,0-2.54,0-2.22-.05-5.41-.09-9.44l.16.15-48.65.1c.11-.11-.25.25.24-.25h0V59.11l-.25-.24L76.26,59l10.24.07,2.77,0,.72,0h.26l-.23,0h-.69l-2.72,0-10.18.07-34.84.11h-.24V52.78c0-1.07,0-2.16,0-3.25V46.26h0c.5-.5.14-.14.26-.25l48.65.1h.15v.15c0,4.07-.07,7.29-.09,9.53,0,1.07,0,1.91,0,2.5l0,.64A1.23,1.23,0,0,1,90.25,59.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.84,46.24s0-.09,0-.24,0-.41,0-.69c0-.63,0-1.49,0-2.58,0-2.25-.06-5.44-.1-9.36l.18.18-29.23.07.25-.25h0v3.33c0,1.11,0,2.2,0,3.28v6.24L67.61,46l20.91.12,6.09.06,1.64,0,.59,0a3.28,3.28,0,0,1-.53,0l-1.59,0-6,.06-21.07.12h-.24v-.24c0-2,0-4.09,0-6.24V33.39h0l.25-.25,29.23.07H97v.18c0,4-.07,7.19-.1,9.47,0,1.07,0,1.92,0,2.54A6.65,6.65,0,0,1,96.84,46.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.8,403.29a1,1,0,0,1,0-.23v-.66c0-.61,0-1.45,0-2.53,0-2.23-.05-5.42-.08-9.45l.15.15-48.65.1.25-.25h0v12.86l-.24-.24,34.67.11,10.23.07,2.77,0,.72,0h.26s-.07,0-.23,0h-.69l-2.71,0-10.18.07-34.84.11h-.25V390.43h0l.25-.25,48.65.1H261v.15c0,4.07-.06,7.29-.08,9.54,0,1.06,0,1.9,0,2.5v.63C260.81,403.23,260.81,403.3,260.8,403.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.4,390.42a.68.68,0,0,1,0-.24c0-.19,0-.41,0-.68,0-.64,0-1.5-.05-2.59,0-2.25-.05-5.44-.09-9.36l.18.18-29.23.07c-.23.22.3-.3.24-.25h0v6.62c0,2.15,0,4.24,0,6.24l-.24-.23,20.92.11,6.09.06,1.64,0,.59,0a3.43,3.43,0,0,1-.53,0l-1.6,0-6,.07-21.07.11h-.23v-.24c0-2,0-4.09,0-6.24v-6.62h0l.25-.25,29.23.07h.18v.18c0,4-.07,7.19-.09,9.47,0,1.07,0,1.92-.05,2.54S267.41,390.43,267.4,390.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.77,375.43a2.07,2.07,0,0,1,0-.23l0-.66c0-.61,0-1.45,0-2.53,0-2.23,0-5.42-.09-9.45l.15.15-48.65.1.25-.25h0v6.52c0,2.15,0,4.26,0,6.33l-.24-.24,34.67.11,10.24.07,2.76,0,.73,0h.25s-.07,0-.22,0h-.7l-2.71,0-10.18.06-34.84.12h-.24v-.25q0-3.1,0-6.33v-6.52h0l.25-.25,48.65.1h.16v.15c0,4.07-.06,7.29-.08,9.54,0,1.06,0,1.9,0,2.49v.64C455.78,375.37,455.78,375.44,455.77,375.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.37,362.56a1.22,1.22,0,0,1,0-.24c0-.19,0-.41,0-.69,0-.63,0-1.49,0-2.58,0-2.25-.06-5.44-.1-9.36l.18.18-29.23.07.25-.25h0V353c0,1.11,0,2.2,0,3.28,0,2.15,0,4.24,0,6.24l-.23-.23,20.91.11,6.09.06,1.64,0,.59,0a3.28,3.28,0,0,1-.53,0l-1.59,0-6,.07-21.07.11h-.24v-.24c0-2,0-4.09,0-6.24V349.7h0l.25-.25,29.23.07h.18v.18c0,4-.07,7.19-.1,9.47,0,1.07,0,1.92,0,2.54S462.38,362.57,462.37,362.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.14,377.64a1.35,1.35,0,0,1,0-.24l0-.66c0-.6,0-1.45,0-2.53,0-2.22,0-5.42-.09-9.44l.16.15L39.49,365l.24-.24h0v12.85l-.25-.24,34.67.11,10.24.06,2.77,0h.72l.26,0h-.23l-.69,0-2.72,0-10.18.07-34.84.11h-.24v-9.82c0-.55,0-1.09,0-1.64v-1.63h0c.5-.5.14-.14.26-.25l48.65.1h.15v.15c0,4.06-.07,7.29-.09,9.53,0,1.07,0,1.9,0,2.5l0,.63A1.66,1.66,0,0,1,88.14,377.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.73,364.77s0-.09,0-.25,0-.41,0-.68c0-.63,0-1.49,0-2.58,0-2.26-.06-5.44-.1-9.36l.18.17-29.23.07c-.22.23.3-.3.25-.24h0v3.33c0,1.11,0,2.2,0,3.28v6.24l-.24-.24,20.91.11,6.09.07,1.65,0,.58,0a3.28,3.28,0,0,1-.53,0l-1.59,0-6,.06L65.5,365h-.24v-6.47c0-1.08,0-2.17,0-3.28v-3.33h0l.25-.25,29.23.07h.18v.18c0,4-.07,7.18-.1,9.47,0,1.07,0,1.91,0,2.54A6.84,6.84,0,0,1,94.73,364.77Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.14,469.57c0,.15-95.43.26-213.13.26s-213.15-.11-213.15-.26,95.41-.26,213.15-.26S463.14,469.43,463.14,469.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.91,442.44s-4-27.34-3.64-43.25,0-33.8,0-33.8h1.83s-1.24,31.57.11,50.61,4.91,26.44,4.91,26.44h-3.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.76,334.62a4.84,4.84,0,0,0-1.67-2.44c-1.16-.74-2.69-.43-4,0-5.53,2-10.44,12.28-12.68,17.71l7.35,24.77C164,362.38,166.34,346.23,161.76,334.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.66,333.18a1.43,1.43,0,0,1-.11.33l-.36.9c-.32.78-.77,1.91-1.31,3.32-1.08,2.81-2.46,6.74-3.7,11.17s-2.07,8.52-2.59,11.48c-.26,1.49-.46,2.69-.59,3.53l-.15.95a1.49,1.49,0,0,1-.08.34,1.74,1.74,0,0,1,0-.34c0-.26.06-.58.1-1,.09-.84.25-2.05.49-3.54a104.68,104.68,0,0,1,6.3-22.7c.57-1.4,1-2.52,1.4-3.29l.42-.88A1.28,1.28,0,0,1,159.66,333.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.51,380.63a22.42,22.42,0,0,1-11.33-18.84c-.27-5.49,1.42-10.89,3.33-16a2.14,2.14,0,0,1,.78-1.17,2,2,0,0,1,1.88.29c5,2.85,8,8.29,9.65,13.82A27.9,27.9,0,0,1,153,370.05a18.94,18.94,0,0,1-5.45,10.58",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.51,380.63s0-.12,0-.34,0-.56,0-1c0-.82,0-2-.1-3.49a97.37,97.37,0,0,0-1.28-11.44c-.77-4.44-1.69-8.41-2.38-11.28-.33-1.4-.61-2.56-.81-3.4l-.22-.93a1.51,1.51,0,0,1,0-.33,1.41,1.41,0,0,1,.11.32l.27.91c.23.79.54,1.95.91,3.38.74,2.86,1.7,6.83,2.47,11.28a84.33,84.33,0,0,1,1.19,11.48c0,1.48,0,2.68,0,3.5,0,.39,0,.7,0,1A1.5,1.5,0,0,1,147.51,380.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.51,380.63a22.42,22.42,0,0,1-11.33-18.84c-.27-5.49,1.42-10.89,3.33-16a2.14,2.14,0,0,1,.78-1.17,2,2,0,0,1,1.88.29c5,2.85,8,8.29,9.65,13.82A27.9,27.9,0,0,1,153,370.05a18.94,18.94,0,0,1-5.45,10.58"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M155.28,422.46c6.78,1.49,12.36,6.27,18.91,8.6,4.32,1.54,9.22,2.08,12.67,5.11-.82-2.1-2.79-3.49-4.7-4.68A84.27,84.27,0,0,0,165,423.31c-3.07-1.07-6.41-2-9.55-1.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.47,428.5c-8.49-.14-17.43-7.37-25.88-7.8,8.84-2.85,21.51-.52,25.88,7.8",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.79,408.13a27.64,27.64,0,0,1,13.58-.93,82.72,82.72,0,0,1,13.25,3.61c-.43-2.95-2.82-5.17-5.06-7.13a36.17,36.17,0,0,0-5.32-4.09,11.93,11.93,0,0,0-6.39-1.8,10.11,10.11,0,0,0-7,3.55,11.78,11.78,0,0,0-3,6.79",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.36,398.75c-5.34-4.56-13.44-4.12-20.47-4a166.88,166.88,0,0,1,31.75,19.79C142.93,409.61,138.12,404.52,131.36,398.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.36,398.75c-5.34-4.56-13.44-4.12-20.47-4a166.88,166.88,0,0,1,31.75,19.79C142.93,409.61,138.12,404.52,131.36,398.75Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M151.2,392.45a59,59,0,0,1,8.22-4.78c2.81-1.28,5.44-3.31,8.16-4.78,3.52-1.91,6.57-4.56,9.81-6.93s6.78-4.5,10.74-5.13a21.19,21.19,0,0,0-9.78.57,63.47,63.47,0,0,0-9.2,3.58c-4.17,1.88-8.41,3.8-11.82,6.85s-6.49,6.06-6.13,10.62",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,428.5a1,1,0,0,1-.27-.12L173,428c-.64-.34-1.56-.84-2.71-1.43-.58-.3-1.21-.61-1.9-.94s-1.42-.67-2.2-1A32,32,0,0,0,161,422.8a11.25,11.25,0,0,0-5.45-.14,15.7,15.7,0,0,0-2.31.69,12.4,12.4,0,0,0-1.86,1,11.69,11.69,0,0,0-2.34,1.93c-.5.53-.73.85-.76.84a2,2,0,0,1,.16-.25,5.21,5.21,0,0,1,.51-.66,10.75,10.75,0,0,1,2.31-2,11.93,11.93,0,0,1,1.89-1,14.61,14.61,0,0,1,2.34-.73,11.27,11.27,0,0,1,5.58.12,30.64,30.64,0,0,1,5.27,1.86c.78.35,1.52.69,2.2,1s1.32.66,1.89,1c1.14.6,2.05,1.14,2.67,1.51l.71.43C174,428.43,174,428.49,174,428.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14,424.29a1.93,1.93,0,0,1,.53.16,12.29,12.29,0,0,1,1.39.6,16.89,16.89,0,0,1,7.09,6.82,12.16,12.16,0,0,1,.66,1.35,1.89,1.89,0,0,1,.17.53s-.36-.7-1-1.78a19.22,19.22,0,0,0-3.07-3.82,18.89,18.89,0,0,0-3.94-2.91C139.85,424.63,139.12,424.34,139.14,424.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.35,398.33a1.41,1.41,0,0,1,.36.1l1,.37,1.61.59c.62.23,1.3.57,2.07.91a49.15,49.15,0,0,1,11.06,7.05,54.12,54.12,0,0,1,5.16,5.07,58.29,58.29,0,0,1,3.66,4.64c1,1.37,1.7,2.52,2.2,3.31l.59.91a1.34,1.34,0,0,1,.18.33s-.09-.1-.23-.29-.37-.5-.63-.88c-.54-.78-1.3-1.9-2.29-3.25s-2.23-2.92-3.69-4.58a55,55,0,0,0-5.15-5,51.31,51.31,0,0,0-11-7.08c-.76-.35-1.43-.71-2-1l-1.58-.63-1-.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.54,403.35a3,3,0,0,1-.68-.08l-.78-.15c-.31-.06-.66-.06-1.05-.1a10.66,10.66,0,0,0-5.83,1.16,10.52,10.52,0,0,0-2.66,2,11.55,11.55,0,0,0-1.7,2.11,16.36,16.36,0,0,0-1.17,2.22,2.36,2.36,0,0,1,.17-.66,10.55,10.55,0,0,1,.81-1.68,11.66,11.66,0,0,1,1.69-2.19,10.39,10.39,0,0,1,8.71-3.14,9.32,9.32,0,0,1,1.06.15l.77.19A3.19,3.19,0,0,1,161.54,403.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.07,376.88a2,2,0,0,1-.32.19l-.95.52c-.82.44-2,1.1-3.45,2s-3.12,1.91-4.92,3.2a40.71,40.71,0,0,0-5.49,4.6,13.94,13.94,0,0,0-2.25,2.91c-.55,1.07-1.09,2.1-1.57,3.09a52,52,0,0,0-2.36,5.37,31.54,31.54,0,0,0-1.15,3.78c-.22.91-.3,1.43-.33,1.42a1.56,1.56,0,0,1,0-.38c0-.24.08-.6.17-1.06a29,29,0,0,1,1.06-3.83,52.32,52.32,0,0,1,2.31-5.42c.49-1,1-2,1.57-3.11a14,14,0,0,1,2.29-3,39.82,39.82,0,0,1,5.55-4.62c1.82-1.28,3.52-2.32,5-3.16s2.67-1.45,3.51-1.87l1-.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.26,402.59a3.53,3.53,0,0,1-.17-.72c-.1-.52-.22-1.18-.37-2a56.49,56.49,0,0,0-1.61-6.37,55.9,55.9,0,0,0-2.42-6.11l-.83-1.82a2.78,2.78,0,0,1-.27-.68,3.7,3.7,0,0,1,.37.63c.23.41.55,1,.92,1.78a42,42,0,0,1,4.05,12.53c.13.84.23,1.52.28,2A3.63,3.63,0,0,1,146.26,402.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.64,383.27a23,23,0,0,0-2.76-9.17,30.29,30.29,0,0,0-20.51-15.3l19,28.31,2.45,5.05A14.48,14.48,0,0,0,145.64,383.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.72,
    y: 439.05,
    width: 44.16,
    height: 7.83,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.02 445.33 135.78 469.62 165.1 469.62 169.59 445.33 132.02 445.33",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.86,446.89c0,.09-10,.16-22.25.16s-22.24-.07-22.24-.16,10-.15,22.24-.15S172.86,446.81,172.86,446.89Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.91,44.87l6.69,15.45,10.64,24.6q1.22,2.81,2.42,5.61c.26.59,1.13.08.88-.51l-6.69-15.45q-5.31-12.3-10.64-24.6l-2.42-5.61c-.26-.6-1.13-.08-.88.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.06,41.57q1.73,18.63,3.46,37.25c.06.64,1.07.65,1,0q-1.72-18.63-3.46-37.25c-.06-.64-1.07-.65-1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.05,44q-.33,16.89-.67,33.8a.51.51,0,0,0,1,0q.33-16.9.67-33.8a.51.51,0,0,0-1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.69,77.6a270.17,270.17,0,0,1,12.59-33.35c.26-.59-.61-1.1-.88-.51a272.45,272.45,0,0,0-12.68,33.59.5.5,0,0,0,1,.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.87 98.27 147.87 82.24 153.63 78.82 153.63 75.49 161.06 75.49 161.06 78.43 167.52 82.14 167.52 98.27 147.87 98.27",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.7,82.14c0,.11-4.48.21-10,.21s-10-.1-10-.21,4.48-.21,10-.21S167.7,82,167.7,82.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.07,78.72a17.43,17.43,0,0,1-3.76.21,17.43,17.43,0,0,1-3.76-.21,16.7,16.7,0,0,1,3.76-.21A16.7,16.7,0,0,1,161.07,78.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.55,
    y: 71.43,
    width: 16.38,
    height: 23.69,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.95,
    y: 80.94,
    width: 15.83,
    height: 14.18,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.74,
    y: 80.94,
    width: 15.83,
    height: 14.18,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.58,95.12a1.73,1.73,0,0,1,0-.28c0-.21,0-.46,0-.78,0-.71,0-1.68,0-2.89,0-2.51-.05-6-.09-10.23l.18.18-15.83,0,.2-.21h0V88.4c0,2.38,0,4.63,0,6.72l-.19-.19,11.41.1,3.25,0,.87,0a1.15,1.15,0,0,1,.31,0l-.27,0-.84,0-3.2,0-11.53.09h-.18v-.18c0-2.09,0-4.34,0-6.72V81h0c-.18.19.26-.26.22-.21l15.83,0h.18v.18c0,4.26-.07,7.81-.09,10.34,0,1.2,0,2.16,0,2.86,0,.3,0,.54,0,.74A1.1,1.1,0,0,1,128.58,95.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.47,74.32a1.92,1.92,0,0,0-1-1,2.21,2.21,0,0,0-2.07.47A3.41,3.41,0,0,0,88.08,77a2.92,2.92,0,0,0,2.47,2.35L90,79.23a2.23,2.23,0,0,0,2.21-1,4,4,0,0,0,.57-2.47A3.51,3.51,0,0,0,92.47,74.32Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.75,76.23a1.15,1.15,0,0,0-.64-.62,1.37,1.37,0,0,0-1.28.29,2.15,2.15,0,0,0-.81,2,1.83,1.83,0,0,0,1.54,1.46l-.34-.09a1.39,1.39,0,0,0,1.38-.63A2.47,2.47,0,0,0,92,77.12,2.07,2.07,0,0,0,91.75,76.23Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.42,78.64c.11,0,.21.57.21,1.27s-.1,1.27-.21,1.27-.21-.57-.21-1.27S90.3,78.64,90.42,78.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,64.88a2,2,0,0,0-1-1,2.21,2.21,0,0,0-2.06.47,3.43,3.43,0,0,0-1.29,3.23,2.91,2.91,0,0,0,2.46,2.34l-.54-.14a2.25,2.25,0,0,0,2.22-1,4.06,4.06,0,0,0,.57-2.47A3.82,3.82,0,0,0,110,64.88Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.29,66.78a1.27,1.27,0,0,0-.65-.62,1.35,1.35,0,0,0-1.28.3,2.1,2.1,0,0,0-.8,2,1.79,1.79,0,0,0,1.53,1.46l-.34-.09a1.37,1.37,0,0,0,1.38-.62,2.59,2.59,0,0,0,.36-1.54A2.5,2.5,0,0,0,109.29,66.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108,69.2c.12,0,.21.57.21,1.27s-.09,1.26-.21,1.26-.21-.56-.21-1.26S107.83,69.2,108,69.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.3,74.75a1.94,1.94,0,0,0-1-1,2.25,2.25,0,0,0-2.07.47,3.43,3.43,0,0,0-1.29,3.23,2.89,2.89,0,0,0,2.47,2.34l-.54-.14a2.21,2.21,0,0,0,2.21-1,4.05,4.05,0,0,0,.57-2.46A3.87,3.87,0,0,0,123.3,74.75Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.58,76.66a1.18,1.18,0,0,0-.64-.62,1.4,1.4,0,0,0-1.29.29,2.12,2.12,0,0,0-.8,2,1.8,1.8,0,0,0,1.53,1.46l-.33-.08a1.42,1.42,0,0,0,1.38-.63,2.48,2.48,0,0,0,.35-1.54A2.4,2.4,0,0,0,122.58,76.66Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.25,79.07c.11,0,.21.57.21,1.27s-.1,1.27-.21,1.27S121,81,121,80.34,121.13,79.07,121.25,79.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.81,80.93a73.23,73.23,0,0,1-8,.22,73.08,73.08,0,0,1-8-.22,78.08,78.08,0,0,1,8-.21A78.24,78.24,0,0,1,98.81,80.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.1,71.48a81.92,81.92,0,0,1-8.36.21,81.92,81.92,0,0,1-8.36-.21c0-.11,3.74-.21,8.36-.21S116.1,71.37,116.1,71.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.78,73.44s.23.25.09.78a1.26,1.26,0,0,1-.61.75,1.28,1.28,0,0,1-1.28-.13,1.21,1.21,0,0,1-.46-.62,2,2,0,0,0-.26-.63c-.1-.1-.24-.07-.34.15a5,5,0,0,0-.19.8,14.48,14.48,0,0,0-.17,3.78,1.78,1.78,0,0,1-.31,1.07,1.17,1.17,0,0,1-1,.44,1.6,1.6,0,0,1-1-.43,2.83,2.83,0,0,1-.59-.76,8.75,8.75,0,0,1-1-3,8.08,8.08,0,0,1,0-2.13,1.91,1.91,0,0,1,.17-.76,15.42,15.42,0,0,0,.15,2.84A9.06,9.06,0,0,0,103,78.45a1.68,1.68,0,0,0,1.25,1,.76.76,0,0,0,.68-.28,1.37,1.37,0,0,0,.21-.83,13.86,13.86,0,0,1,.22-3.85,4.88,4.88,0,0,1,.23-.87.75.75,0,0,1,.38-.39.53.53,0,0,1,.56.16,2.06,2.06,0,0,1,.3.76,1,1,0,0,0,.34.48,1,1,0,0,0,1,.16,1.11,1.11,0,0,0,.55-.59A1.64,1.64,0,0,0,108.78,73.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.79,95.12H77.5c1.32,1.81,3.42,3,6.84,3.21h46.72c3.78,0,5.67-1.61,6.44-3.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.95,
    y: 98.29,
    width: 103.8,
    height: 12.21,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.8,
    y: 109.07,
    width: 7.71,
    height: 7.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.37,
    y: 109.07,
    width: 7.71,
    height: 7.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.61,110.65c0,.12-23,.21-51.31.21S73,110.77,73,110.65s23-.21,51.32-.21S175.61,110.53,175.61,110.65Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.72,99.27l3.48-7.09a25.41,25.41,0,1,1,4.62,7.85h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.72,99.27l.5.06,1.54.16,6.05.64a.09.09,0,0,0,.1-.08.07.07,0,0,0,0,0h0l-.15.09A25.43,25.43,0,0,0,374,107.3a25,25,0,0,0,3.79,1.12,28,28,0,0,0,4.2.52,25.42,25.42,0,0,0,18-6.32,25.66,25.66,0,0,0,6.51-8.84,25.33,25.33,0,0,0,2.14-11.45,25,25,0,0,0-3.43-11.7l-.81-1.35L403.38,68l-.46-.63-.52-.58-1-1.16c-.36-.37-.75-.71-1.12-1.06a13.75,13.75,0,0,0-1.16-1,22.42,22.42,0,0,0-2.49-1.76,25.49,25.49,0,0,0-30.79,2.81A25.3,25.3,0,0,0,360.24,72a27.61,27.61,0,0,0-1.6,3.94,34.27,34.27,0,0,0-.86,3.87,25.21,25.21,0,0,0,1.34,12.4v-.07c-1.11,2.32-2,4.1-2.56,5.32-.27.59-.49,1-.64,1.36s-.2.45-.2.45l.24-.47c.17-.32.39-.77.69-1.36.6-1.2,1.48-3,2.63-5.22a.08.08,0,0,0,0-.07,25.27,25.27,0,0,1-1.23-12.31,33.92,33.92,0,0,1,.87-3.81,28.94,28.94,0,0,1,1.59-3.89,25.33,25.33,0,0,1,25-13.74,25.63,25.63,0,0,1,10.9,3.75,24.21,24.21,0,0,1,2.45,1.74c.41.29.76.66,1.14,1s.75.68,1.1,1.05l1,1.14.51.57.45.62.92,1.25.79,1.33a24.52,24.52,0,0,1,3.38,11.51,25,25,0,0,1-2.09,11.27A25.34,25.34,0,0,1,391,107.35a25,25,0,0,1-9,1.27,27.53,27.53,0,0,1-4.16-.49,23.4,23.4,0,0,1-3.75-1.09A25.34,25.34,0,0,1,363.88,100a.08.08,0,0,0-.12,0,.08.08,0,0,0,0,.1v0l.09-.13-6-.52-1.56-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.73 83.9 374.01 80.61 380.35 86.24 392.78 74.28 395.83 77.56 379.88 92.58 370.73 83.9",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.83,228.05l.28-7.11a22.68,22.68,0,1,1,6.83,4.39h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.83,228.05l.48-.2,1.36-.54,5.25-2.06,0,.16h0a.09.09,0,0,1,0-.13.1.1,0,0,1,.1,0,22.52,22.52,0,0,0,11,1.54,21.85,21.85,0,0,0,6.92-1.93,22.34,22.34,0,0,0,6.64-4.64,22.39,22.39,0,0,0-3.59-34.45,22.17,22.17,0,0,0-10.14-3.61,22.66,22.66,0,0,0-10.2,1.35,22.2,22.2,0,0,0-8.09,5.34,22.5,22.5,0,0,0,.68,32,.11.11,0,0,1,0,.07c-.11,2.28-.2,4.05-.26,5.26,0,.59-.06,1-.07,1.37s0,.48,0,.48,0-.14,0-.44,0-.77,0-1.35c0-1.23.09-3,.16-5.33l0,.07a22.49,22.49,0,0,1-6-9.37,22.78,22.78,0,0,1,.32-15.36,23,23,0,0,1,4.9-7.7,22.65,22.65,0,0,1,8.22-5.44,23.16,23.16,0,0,1,10.38-1.39,22.52,22.52,0,0,1,10.32,3.67A22.75,22.75,0,0,1,130,225.14a22.46,22.46,0,0,1-18.1.27l.09-.15h0a.09.09,0,0,1,0,.13l0,0-5.35,2-1.35.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.68,205a2.15,2.15,0,1,1-2.15-2.15A2.15,2.15,0,0,1,114.68,205Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.28,205a2.15,2.15,0,1,1-2.15-2.15A2.15,2.15,0,0,1,123.28,205Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.86,203.89a2.15,2.15,0,1,1-2.94-.79A2.14,2.14,0,0,1,131.86,203.89Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.35,
    y: 284.53,
    width: 40.32,
    height: 20.35,
    rx: 8.29,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.51 456.97 320.89 447.75 304.56 447.73 306.34 458.43 312.18 461.95 322.51 456.97",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,457.57v1.06s-17.82,7.36-18,10.76l35.53-.53-.66-11.81A20.31,20.31,0,0,1,306,457.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.34,460.88a1.45,1.45,0,0,1,1,1.64,1.39,1.39,0,0,1-1.62,1,1.53,1.53,0,0,1-1.08-1.74,1.45,1.45,0,0,1,1.8-.89",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.54,468.86l-.16-2.84-34,1.54s-1.57.71-1.37,1.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.87,458.73c0,.17.88.24,1.74.79s1.33,1.26,1.49,1.19-.12-1.07-1.17-1.71S305.83,458.57,305.87,458.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.17,460.33c0,.17.71.45,1.31,1.18s.79,1.49,1,1.48.27-1-.5-1.88S302.17,460.16,302.17,460.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.11,464.82c.16,0,.39-.84-.07-1.78s-1.27-1.31-1.35-1.16.44.64.81,1.42S299.94,464.8,300.11,464.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.14 439.73 323.96 467.16 336.53 465.06 336.81 438.06 321.14 439.73",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.48,459.86s-8.32,7-13.14,2.09l-.88,2.69-3.31,18.89a2.45,2.45,0,0,0,4.25,2.09c3.34-3.75,15.56-17.58,15.27-19.27l-.49-4.52a2.32,2.32,0,0,0-1.7-2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.31,486.43l17.21-21.65.09,1a2.76,2.76,0,0,1-.69,2.27c-1.36,2.18-5.2,7.13-14.44,17.58a2.5,2.5,0,0,1-2.17.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.44,462.1a1.38,1.38,0,1,0,1.72,2.16,1.38,1.38,0,1,0-1.82-2.06",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325.85,475.75a7.35,7.35,0,0,0-2.27-1.62,7.62,7.62,0,0,0-2.8-.26c0-.06.26-.27.81-.4a4,4,0,0,1,2.18.18,3.76,3.76,0,0,1,1.74,1.28C325.84,475.38,325.9,475.72,325.85,475.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.43,479a19.71,19.71,0,0,0-2.21-.81,20.25,20.25,0,0,0-2.37-.08,2.83,2.83,0,0,1,2.47-.43C323.77,478,324.55,479,324.43,479Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.65,471.46a24.51,24.51,0,0,0-3.32-1.47,24.07,24.07,0,0,0-3.62-.48,5.59,5.59,0,0,1,3.77,0A5.39,5.39,0,0,1,328.65,471.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.54,465.82c-.05.14-1.42-.28-3.15-.18s-3.05.63-3.11.49a6.23,6.23,0,0,1,6.26-.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.41,465.68a2.06,2.06,0,0,1,0-.88,6.24,6.24,0,0,1,.94-2.25,2.78,2.78,0,0,1,1.32-1.19,1,1,0,0,1,1.09.3,1.61,1.61,0,0,1,.28,1.09,3.48,3.48,0,0,1-3.34,2.87,4,4,0,0,1-3.75-2.39,1.34,1.34,0,0,1,0-1.14,1,1,0,0,1,1.06-.41,3.51,3.51,0,0,1,1.5.93,6.79,6.79,0,0,1,1.46,2,2,2,0,0,1,.29.83,11,11,0,0,0-2-2.52,3.15,3.15,0,0,0-1.33-.78.53.53,0,0,0-.58.22.94.94,0,0,0,0,.75,3.58,3.58,0,0,0,3.28,2,3,3,0,0,0,2.86-2.39,1.13,1.13,0,0,0-.16-.77.56.56,0,0,0-.6-.18,2.54,2.54,0,0,0-1.13,1A9,9,0,0,0,324.41,465.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,244.49a117.19,117.19,0,0,0-6.56,36c-.33,19.77,18,75.8,20.71,88.66,1.87,8.75,9.85,52.5,19.86,78.94l15-.55s-12.53-89-12.53-98.31,1.36-59,1.36-59l3.32-37.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.71,241.69c-1.1.42-37,9.09-37,9.09S298.53,353.24,298,366.69,319,447.57,319,447.57h20.63s-.88-43.21-4-57c-3.62-15.94-7-19.49-5.5-28.13s17.28-50.42,21.2-73.32S344.71,241.69,344.71,241.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.52,266.49s.28,0,.77.07a18.31,18.31,0,0,1,2,.49,26.47,26.47,0,0,1,6.35,2.79,27.45,27.45,0,0,1,5.44,4.31,20.64,20.64,0,0,1,1.38,1.59c.3.39.46.62.43.64s-.78-.77-2.06-2a31.91,31.91,0,0,0-11.65-7C282.57,266.82,281.5,266.57,281.52,266.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,447.57l-.36,0-1.05,0-4.09,0-15.42.07h-.12l0-.11c-2.45-8.31-5.58-19.05-9.1-31.43s-7.51-26.36-11.18-41.31c-.37-1.62-.76-3.23-1.06-4.86a26.34,26.34,0,0,1-.42-4.91c0-3.25,0-6.44.08-9.58.13-6.28.34-12.34.53-18.1.42-11.54.87-21.92,1.28-30.63s.78-15.77,1.05-20.64c.16-2.42.28-4.31.36-5.61,0-.64.08-1.13.12-1.46s.07-.49.07-.49c-.06,1.36-.49,11-1.24,28.21-.36,8.72-.78,19.1-1.17,30.63-.19,5.77-.39,11.82-.51,18.09-.05,3.14-.11,6.34-.07,9.57a25.22,25.22,0,0,0,.42,4.83c.29,1.61.68,3.22,1.05,4.84,3.67,14.92,7.67,28.91,11.12,41.3s6.59,23.12,9,31.47l-.15-.12,15.42.08,4.09,0,1.05,0A1.41,1.41,0,0,1,340,447.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.46,266.53c0,.1-1.71-.06-4.44.1a36.83,36.83,0,0,0-4.76.58,41.62,41.62,0,0,0-5.66,1.54,40.18,40.18,0,0,0-5.34,2.41,37.06,37.06,0,0,0-4.05,2.56c-2.21,1.62-3.42,2.82-3.49,2.75a5.22,5.22,0,0,1,.81-.89c.27-.27.61-.6,1-.95s.88-.78,1.43-1.19a34,34,0,0,1,4-2.69,34.89,34.89,0,0,1,11.15-4,31.7,31.7,0,0,1,4.82-.49c.69,0,1.32,0,1.87,0a13.11,13.11,0,0,1,1.4.08A5.38,5.38,0,0,1,329.46,266.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.31,329.75c.05.16,67,0,67,0l4.58-15.21H289l-18.45,4.77Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.25,123.73a9.6,9.6,0,0,1-.82-13.22,6.78,6.78,0,0,1-.95-9.64A9,9,0,0,1,310,87.07l1.33-16.19c3.31-3.93,7.4-1.91,8.33-.43a7.81,7.81,0,0,1,9.65,8.45,9.07,9.07,0,0,1,3.8,13.66,11,11,0,0,1,6,14.68,7.3,7.3,0,0,1,4.95,12.22,5.65,5.65,0,0,1-4.2,9.94,7.34,7.34,0,0,1-12.31,4.6,7,7,0,0,1-11.77.07,5.89,5.89,0,0,1-5.55-10.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.16,80.39c3.12.51,4.09,2.82,5,4.73,2,4.11,1.46,10.72-.38,14.89s-4.18,6.52-8.55,7.84q-1.77-10.23-3.55-20.46Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.63,91.92a7.18,7.18,0,0,0-2-9c1.06-1.83.21-4.28-1.36-5.7a14.15,14.15,0,0,0-5.69-2.63,9.69,9.69,0,0,0-12.22-5.29c-3-3.26-8.38-3-12.42-1.16a11.42,11.42,0,0,1-3,1.16,17.33,17.33,0,0,1-2.39,0c-4.39.08-8.2,3.75-9.26,8a8.62,8.62,0,0,1-.63,2,11.13,11.13,0,0,1-1.87,2,6.93,6.93,0,0,0-1.86,5.47c.18,1.68,1,3.37.51,5-.23.82-.78,1.53-.93,2.36-.45,2.41,2.45,4.37,2.34,6.82,0,.51-.17,1-.23,1.49a4.27,4.27,0,0,0,.7,2.92,6.1,6.1,0,0,1,1.26,2,7.21,7.21,0,0,1-.08,1.79c-.08,1.46,3.82,6.48,5.16,7.06L313.36,111a7,7,0,0,0,4.41-6.72,2.46,2.46,0,0,1,.14-1.4,3,3,0,0,1,.9-.8c2.17-1.63,2-4.92,1.31-7.55a3.29,3.29,0,0,1-.15-1.12A4.22,4.22,0,0,1,320.63,91.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.12,93.57A19.88,19.88,0,0,0,297.1,78a24.72,24.72,0,0,0-9.72-.84A15.06,15.06,0,0,0,279,80.31c-1.95.78-8.33,8.7-7.6,16.12.82,8.25,2.14,18.28,4.1,24.22,3.94,11.93,13.58,12,13.58,12s2.22,20.49,2.22,20.49l20.35,12.08,3.47-24.63Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.21,115.15a2.43,2.43,0,0,0-1.38-1A2.48,2.48,0,0,0,289,115.2c-.58,1-.24,2,.41,3h0c.75.44,1.39.92,2.21.63.13,0,.25-.1.38-.15a2.75,2.75,0,0,0,1.37-1.42A2.39,2.39,0,0,0,293.21,115.15Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.52,106.41a1.61,1.61,0,0,0,1.78,1.34,1.53,1.53,0,0,0,1.39-1.68,1.59,1.59,0,0,0-1.78-1.34A1.52,1.52,0,0,0,276.52,106.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,100.67c.23.18,1.28-.9,3-1.17s3.06.37,3.21.14-.18-.45-.78-.75a4.39,4.39,0,0,0-2.62-.37,4.24,4.24,0,0,0-2.32,1.19C275,100.2,274.87,100.6,275,100.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,112.41a11,11,0,0,0-2.82,0c-.44,0-.86,0-1-.28a2.13,2.13,0,0,1,.08-1.32c.23-1.11.48-2.28.74-3.5,1-5,1.66-9,1.46-9.06s-1.18,4-2.19,8.92c-.24,1.23-.47,2.39-.68,3.51a2.47,2.47,0,0,0,.05,1.73,1.11,1.11,0,0,0,.81.52,3,3,0,0,0,.75,0A11.05,11.05,0,0,0,287,112.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.08,132.61a31.73,31.73,0,0,0,15.75-7.06s-3,9.35-15.41,10.2Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,93.73c.35.37,1.6-.12,3.13-.24s2.85.08,3.13-.35c.12-.21-.12-.58-.71-.91a4.6,4.6,0,0,0-2.59-.47,4.54,4.54,0,0,0-2.45.95C275,93.14,274.84,93.55,275,93.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.21,103.74a1.59,1.59,0,0,1-1.32,1.78,1.52,1.52,0,0,1-1.81-1.22,1.59,1.59,0,0,1,1.32-1.78A1.52,1.52,0,0,1,295.21,103.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.22,97.57c-.18.23-1.48-.51-3.18-.29s-2.84,1.22-3.05,1,.05-.48.55-.94a4.37,4.37,0,0,1,2.4-1.09,4.13,4.13,0,0,1,2.56.49C298.08,97.11,298.3,97.46,298.22,97.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.21,90.93c-.29.43-1.65.19-3.23.37s-2.88.62-3.23.26c-.16-.18,0-.6.54-1a5.18,5.18,0,0,1,5.2-.51C297.1,90.35,297.33,90.72,297.21,90.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,105.5c-.15-.91.56-3.23,1.44-3.52,2.34-.77,6.71-1.28,7.74,4.82,1.42,8.34-7.25,8-7.3,7.81S310.55,108.65,310,105.5Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.7,111.17s.16.07.43.15a1.52,1.52,0,0,0,1.09-.17c.82-.47,1.33-2,1.11-3.5a4.81,4.81,0,0,0-.76-2,1.71,1.71,0,0,0-1.28-.93.76.76,0,0,0-.79.55c-.07.25,0,.41,0,.43s-.2-.11-.2-.47a.93.93,0,0,1,.24-.57,1.13,1.13,0,0,1,.77-.35,2.08,2.08,0,0,1,1.74,1,5.09,5.09,0,0,1,.9,2.24c.23,1.69-.36,3.41-1.51,4a1.58,1.58,0,0,1-1.37,0C313.75,111.37,313.67,111.19,313.7,111.17Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.57,96.85a4.91,4.91,0,0,0,1.93-4.91c1.18.15,2.08-1.47,2.57-2.55s1.22-1.69,1-2.85a1.35,1.35,0,0,1,0-.69c.12-.35.5-.52.83-.68a5.64,5.64,0,0,0,3-4.49,11.94,11.94,0,0,0,5.88,0,4.59,4.59,0,0,0,7.6-1.57,4.14,4.14,0,0,0,3,1.56,12.14,12.14,0,0,0,3.49-.38,4.87,4.87,0,0,0,4,4.92c.32,0,.68.07.86.33a1.2,1.2,0,0,1,0,1,3.82,3.82,0,0,0,3.3,4.39,2.86,2.86,0,0,0,1,4.37c.33.13.77.29.78.65a.91.91,0,0,1-.13.38,5.54,5.54,0,0,0-.87,3,2,2,0,0,0,2,2,2.71,2.71,0,0,0-.77,2c.11.73,1,1.35,1.6,1,.27-.16,4.29-1.65,4.44-1.93,1.84-3.59-1.71-6.65-2.59-10.59A26.23,26.23,0,0,0,307.13,81a18.91,18.91,0,0,0-3.61-3.54,25.21,25.21,0,0,0-5.14-2.64,23.47,23.47,0,0,0-7.22-2.11c-4.68-.33-9.1,2.07-13,4.69a20.1,20.1,0,0,0-4.1,3.41,17.89,17.89,0,0,0-3,5.61,22.53,22.53,0,0,0-1.64,9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.46,94.19a3.39,3.39,0,0,1,.3-1c.14-.3.33-.67.5-1.12a3.8,3.8,0,0,0,.22-1.64,11.7,11.7,0,0,0-.37-2.06,9.15,9.15,0,0,1-.33-2.49,7,7,0,0,1,.67-2.81,6.8,6.8,0,0,1,.84-1.34,10.08,10.08,0,0,1,1.16-1.2,5.06,5.06,0,0,0,1.09-1.3,6.51,6.51,0,0,0,.54-1.7A11.35,11.35,0,0,1,276.43,71a9.75,9.75,0,0,1,1.89-1.08,8.68,8.68,0,0,1,2.15-.6,11,11,0,0,1,1.14-.1l1.15,0a5.34,5.34,0,0,0,2.23-.36c.72-.27,1.41-.65,2.15-1a16.45,16.45,0,0,1,2.3-.8,14.41,14.41,0,0,1,2.45-.41,12.51,12.51,0,0,1,2.52.05,8.33,8.33,0,0,1,4.65,2.1l.38.36-.14,0a9.82,9.82,0,0,1,12.37,5.37l-.08-.07a25.81,25.81,0,0,1,3.18,1.07,8.89,8.89,0,0,1,2.73,1.76A5.84,5.84,0,0,1,319.05,80a4,4,0,0,1-.34,3l0-.14a7,7,0,0,1,2.61,4,7.23,7.23,0,0,1-.2,4.29,7,7,0,0,1-.43.92,8.45,8.45,0,0,0-.45.83,1.93,1.93,0,0,0-.17.87,5,5,0,0,0,.17.86,14.66,14.66,0,0,1,.42,3.19,6.91,6.91,0,0,1-.44,2.54,4.13,4.13,0,0,1-1.08,1.57c-.39.35-.75.52-.94.71a3.43,3.43,0,0,0-.26.3,1.07,1.07,0,0,1,.24-.32c.18-.2.55-.38.92-.74a4.15,4.15,0,0,0,1-1.55,6.58,6.58,0,0,0,.4-2.51,13.84,13.84,0,0,0-.44-3.15,5,5,0,0,1-.17-.89,1.94,1.94,0,0,1,.17-.94c.13-.3.3-.57.46-.86a8,8,0,0,0,.41-.89,7,7,0,0,0,.17-4.18A6.84,6.84,0,0,0,318.55,83l-.07-.05,0-.09a3.78,3.78,0,0,0,.32-2.79,5.67,5.67,0,0,0-1.5-2.6,8.76,8.76,0,0,0-2.67-1.7,25.31,25.31,0,0,0-3.15-1.06l0,0,0,0a9.57,9.57,0,0,0-12.05-5.22l-.07,0-.07-.06-.36-.35a8.15,8.15,0,0,0-4.51-2,12.78,12.78,0,0,0-2.47-.05,14.66,14.66,0,0,0-2.4.4,14.5,14.5,0,0,0-2.27.79c-.73.31-1.42.7-2.17,1a5.58,5.58,0,0,1-1.15.31,7.65,7.65,0,0,1-1.17.06c-.38,0-.76,0-1.14,0a10.38,10.38,0,0,0-1.11.09,8.75,8.75,0,0,0-2.09.58,9.32,9.32,0,0,0-1.85,1.05,11.17,11.17,0,0,0-4.29,6.43,6.94,6.94,0,0,1-.56,1.74,5.13,5.13,0,0,1-1.14,1.34,11.48,11.48,0,0,0-1.15,1.17,7.31,7.31,0,0,0-.82,1.31,6.87,6.87,0,0,0-.68,2.75,9.11,9.11,0,0,0,.31,2.46,12.37,12.37,0,0,1,.35,2.08,3.92,3.92,0,0,1-.25,1.67c-.18.45-.38.81-.52,1.11a5.85,5.85,0,0,0-.28.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.13,68.1s-.24-.09-.68-.22a5.65,5.65,0,0,0-1.91-.24,5.25,5.25,0,0,0-2.68.84,5.57,5.57,0,0,0-2.14,2.66,4.69,4.69,0,0,0-.26,1,1.06,1.06,0,0,0,.2.87l.25.25-.35,0A3.53,3.53,0,0,0,285,74a3.35,3.35,0,0,0-1.17,1.78,3.57,3.57,0,0,0-.11,1.43c0,.33.1.51.08.52s0,0-.06-.13a3.29,3.29,0,0,1-.11-.38,3.57,3.57,0,0,1,0-1.48,3.46,3.46,0,0,1,1.19-1.9,3.66,3.66,0,0,1,2.7-.8l-.1.21a1.29,1.29,0,0,1-.28-1.08,5.12,5.12,0,0,1,.28-1.07,5.63,5.63,0,0,1,2.24-2.77,5.41,5.41,0,0,1,2.81-.82,5.21,5.21,0,0,1,1.94.32A5.31,5.31,0,0,1,295,68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.22,75.52a1.25,1.25,0,0,1-.25.35,5.08,5.08,0,0,1-.84.81,4,4,0,0,1-1.58.76,3,3,0,0,1-2.18-.29l.18-.06-.19.38c-.07.13-.15.25-.23.38a5.07,5.07,0,0,1-1.88,1.63,5.37,5.37,0,0,1-1.95.57,4.44,4.44,0,0,1-1.36-.09,1.89,1.89,0,0,1-.48-.16,7.81,7.81,0,0,0,1.82.07,5.35,5.35,0,0,0,1.86-.6,5,5,0,0,0,1.78-1.57l.22-.35.18-.36.07-.13.11.07a2.86,2.86,0,0,0,2,.3,4,4,0,0,0,1.53-.69A13.86,13.86,0,0,0,310.22,75.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.87,82.57s0,.05,0,.15a1.85,1.85,0,0,1-.12.44,2.29,2.29,0,0,1-1.21,1.11,4.32,4.32,0,0,1-2.42.12,13.89,13.89,0,0,1-1.41-.31,2.29,2.29,0,0,1-1.32-.87l-.07-.12.2,0A9.74,9.74,0,0,1,307.29,85a4.29,4.29,0,0,1-2.3.62,3.15,3.15,0,0,1-1.55-.43,2.27,2.27,0,0,1-.36-.26l-.1-.11s.17.12.5.29a3.35,3.35,0,0,0,1.51.33,4.32,4.32,0,0,0,2.19-.64,10.19,10.19,0,0,0,2.17-1.86l.11-.12.09.15.07.11a2.07,2.07,0,0,0,1.18.76c.46.14.93.23,1.37.32a4.23,4.23,0,0,0,2.31-.06,2.22,2.22,0,0,0,1.19-1A2.65,2.65,0,0,0,315.87,82.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.73,113.61c-.25,0-.31,1.6-1.75,2.71s-3.16.86-3.18,1.09.38.33,1.11.38a4,4,0,0,0,2.65-.82,3.53,3.53,0,0,0,1.36-2.28C293,114,292.84,113.6,292.73,113.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.25,139.53s7.83,2.18,12.56,6.93c3,3,24.39,21.78,24.39,21.78l-18.79,18.12L337.8,173.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.25,139.53l-23.09-5.8s-.48,11.64-9.4,16.57c0,0,6.51,52.53,6.27,63.29s.48,73.54.48,73.54,30.72-7.15,38.83-11.52l5.23-2.93c-3.62-20.54-10.11-38.26-15.28-55.11l-2.19-44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.61,137.48c-1,.9-26.09,12.59-26.09,12.59l13.74,60.3s-15.43,43.61-17.36,54v10.11l51.61,12.69V172.4l-6.75-22.1C296.51,149.5,292.47,146,289.61,137.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.2,196.29c.73-1.42,12.43-27.55,16.21-34.63,5.49-10.31,10.21-12.16,10.21-12.16l7.7,34.83L259.06,209Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.16,191c-.13,0-2.25-6.33-4.73-14.22s-4.38-14.34-4.24-14.38,2.26,6.32,4.73,14.22S273.3,190.92,273.16,191Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.67,269.45a1.05,1.05,0,0,1-.05-.31c0-.23,0-.52-.07-.9-.06-.82-.14-2-.24-3.46-.18-3-.42-7.38-.68-12.77-.51-10.78-1.11-25.67-1.77-42.13s-1.28-31.35-1.83-42.13c-.31-5.35-.55-9.7-.72-12.75-.1-1.48-.17-2.64-.23-3.47,0-.37,0-.67,0-.9a1.19,1.19,0,0,1,0-.31,1,1,0,0,1,0,.3l.1.9c.08.83.18,2,.32,3.46.25,3,.56,7.37.88,12.75.65,10.78,1.33,25.67,2,42.13S309.59,241.18,310,252c.22,5.36.39,9.71.51,12.77.06,1.48.11,2.64.14,3.47q0,.56,0,.9A1.43,1.43,0,0,1,310.67,269.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.18,149.32c.14,0-.11,7.69-.56,17.16s-.94,17.15-1.09,17.14.11-7.69.57-17.16S346,149.31,346.18,149.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M338.47,210a3.58,3.58,0,0,0-2.35-.85,118.39,118.39,0,0,0-51.13,6l-10.47,4.17c2.62,3.72,7.86,4.18,12.41,4.13a193.65,193.65,0,0,0,39.85-4.6c3.84-.85,7.84-1.92,10.69-4.63C338.63,213.09,339.54,211.18,338.47,210Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M372.48,169.9c.4,1,15.11,15,17.49,20.13s3.73,13.26-2.81,17S351,201.18,351,201.18l2-13.41,15.48,2.7-10-7Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.23,195c-.06.06-.66-.59-1.76-1.43a16.18,16.18,0,0,0-10.1-3.35c-1.39,0-2.25.18-2.27.09a6.41,6.41,0,0,1,2.25-.46,14.5,14.5,0,0,1,5.52.69,14.25,14.25,0,0,1,4.83,2.74A5.84,5.84,0,0,1,382.23,195Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.23,316.65c.08.12-39.19,23-87.68,51s-87.88,50.7-88,50.58,39.18-23,87.69-51S247.16,316.52,247.23,316.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.83,320.71c.07-.12,40.34,22.46,89.94,50.43S249.53,421.9,249.46,422s-40.33-22.45-90-50.43S69.76,320.84,69.83,320.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.09,
    y: 318.47,
    width: 9.32,
    height: 151.1,
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.29,316.65c.08.12-39.18,23-87.68,51s-87.87,50.7-88,50.58,39.19-23,87.69-51S421.22,316.52,421.29,316.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.89,320.71c.07-.12,40.34,22.46,89.94,50.43S423.59,421.9,423.52,422s-40.33-22.45-89.95-50.43S243.82,320.84,243.89,320.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.57,
    y: 307.3,
    width: 9.32,
    height: 162.27,
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.95,
    y: 319.32,
    width: 9.32,
    height: 150.25,
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.83,321.74H43.61a11,11,0,0,1-11-11h0a11,11,0,0,1,11-11h66.22a11,11,0,0,1,11,11h0A11,11,0,0,1,109.83,321.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.83,321.74l.52-.05.64-.05.87-.14a10.9,10.9,0,0,0,7.36-16.15,10.84,10.84,0,0,0-4.62-4.3,10.29,10.29,0,0,0-3.27-1,28.86,28.86,0,0,0-3.63-.1H100l-17.12,0-39.22,0a10.74,10.74,0,0,0-4.35,20.56c2.83,1.37,6,.81,9,.93l32,.06,21.6.08,5.87.05,1.52,0,.52,0s-.17,0-.52,0l-1.52,0-5.87,0-21.6.09-32,.05H43.71a11.25,11.25,0,1,1-.1-22.5l39.22,0,17.12,0,7.75,0a28.12,28.12,0,0,1,3.68.12,10.72,10.72,0,0,1,3.39,1.05,11.11,11.11,0,0,1,2.38,18.36,10.85,10.85,0,0,1-5.27,2.52l-.88.12-.64,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.88,321.74H356.63a11,11,0,0,1-11-11h0a11,11,0,0,1,11-11h77.25a11,11,0,0,1,11,11h0A11,11,0,0,1,433.88,321.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.88,321.74a22.55,22.55,0,0,0,2.25-.28,11.26,11.26,0,0,0,5.56-3.12,11,11,0,0,0,2.42-3.94,10.65,10.65,0,0,0,.46-5.44,10.72,10.72,0,0,0-2.78-5.6,11.19,11.19,0,0,0-2.72-2.11,11,11,0,0,0-3.43-1.16,23.06,23.06,0,0,0-3.84-.15H419.13l-19,0-43.51,0a10.74,10.74,0,0,0-9.54,15.67,10.68,10.68,0,0,0,8.26,5.73,22.09,22.09,0,0,0,2.58.09h7.66l35.54.06,24,.08,6.51.05,1.69,0,.58,0s-.19,0-.58,0l-1.69,0-6.51,0-24,.09L365.6,322h-7.66a23.32,23.32,0,0,1-2.63-.08,11.48,11.48,0,0,1-5-1.89,11.25,11.25,0,0,1,6.37-20.53l43.51,0,19,0,8.61,0h4.06a24.1,24.1,0,0,1,3.9.17,11.69,11.69,0,0,1,3.54,1.22,11.41,11.41,0,0,1,2.79,2.19,10.61,10.61,0,0,1,1.89,2.78,10.44,10.44,0,0,1,.94,3,11.11,11.11,0,0,1-3,9.57,11.12,11.12,0,0,1-5.68,3.08,10.3,10.3,0,0,1-1.69.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.57,321.74H131.66a11,11,0,0,1-11-11h0a11,11,0,0,1,11-11H334.57a11,11,0,0,1,11,11h0A11,11,0,0,1,334.57,321.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.57,321.74a11.63,11.63,0,0,0,4.65-1.1,10.9,10.9,0,0,0,.89-19.24,10.79,10.79,0,0,0-5.37-1.51h-6.18l-29,0L131.68,300a10.72,10.72,0,0,0-5.68,1.63,10.77,10.77,0,0,0-4,4.34,10.76,10.76,0,0,0,5.52,14.69,11.25,11.25,0,0,0,2.79.73,25.61,25.61,0,0,0,2.92.09h56.27l75.48.06,50.89.08,13.83.05,3.6,0,1.22,0-1.22,0-3.6,0-13.83,0-50.89.09-75.48.05L145,322H133.28a27.19,27.19,0,0,1-3-.09,11.82,11.82,0,0,1-2.93-.76,11.25,11.25,0,0,1-5.78-15.4,10.38,10.38,0,0,1,1.75-2.56,10.63,10.63,0,0,1,2.38-2,11.37,11.37,0,0,1,6-1.7l167.89.07,29,0,6.18,0a11,11,0,0,1,5.5,1.57,11.06,11.06,0,0,1-4.44,20.51C335,321.75,334.57,321.74,334.57,321.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.26,220.17c14.71-3,28.91-5,38.54-6.76s19.1-3,19.1-3l0-19.84c.13,0-67.15-2.72-87.45-3.62a22.69,22.69,0,0,0-12.85,3.2c-5.42,3.3-11.43,9.45-9.13,19.95,2.2,10.05,22.68,54.64,22.68,54.64l47.19-2.26-32.8-44.39C252.85,218.63,260.13,221,264.26,220.17Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.27,203.75a2.75,2.75,0,0,1,.82.21,15.92,15.92,0,0,1,2.1.87,22.65,22.65,0,0,1,10.42,10.58,16.45,16.45,0,0,1,.84,2.12c.16.51.23.8.19.81s-.48-1.09-1.36-2.77A25.3,25.3,0,0,0,239,205.16C237.36,204.25,236.24,203.84,236.27,203.75Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.49,242.88c-6.08-1.86-47.68-12.32-48.41-8S235,265,235,265l.58,8.46,53.43-5.6S273.57,244.75,267.49,242.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.62,205s-2.75-.18-2.35,3.13a56.51,56.51,0,0,0,1.74,7.69l2.38,3.58s3.38-.14,2.75-3S249.62,205,249.62,205Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.27,200.8a1.29,1.29,0,0,0-1.4-.65,1.83,1.83,0,0,0-1.39,1.33,7.38,7.38,0,0,0,.58,4.52l4.16,11.07-3.42,2.27,4.29,6.46s7.79-.32,9.94-3.43-.26-11.17-.26-11.17-3.65-6.14-4.79-6.11a10.64,10.64,0,0,0-1.61.11s-2.09-4.5-3.78-4.54-1.93.86-1.93.86Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.56,205.34a9.56,9.56,0,0,1,1,2c.57,1.24,1.32,3,2.13,4.9a20.85,20.85,0,0,1,1,2.79,3.34,3.34,0,0,1-.26,2.49,2.19,2.19,0,0,1-1.32,1,.87.87,0,0,1-.62,0s.23,0,.56-.16a2.17,2.17,0,0,0,1.06-1,3,3,0,0,0,.11-2.19,25.2,25.2,0,0,0-1-2.71c-.81-1.92-1.51-3.68-2-5A9,9,0,0,1,249.56,205.34Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.11,216.23a11.58,11.58,0,0,1-.79-2.18c-.44-1.35-1.07-3.21-1.82-5.25s-1.51-3.84-2.06-5.16a11.23,11.23,0,0,1-.82-2.16,9.32,9.32,0,0,1,1.16,2c.63,1.28,1.44,3.09,2.21,5.13a53.53,53.53,0,0,1,1.68,5.33A8.75,8.75,0,0,1,258.11,216.23Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.81,214.78s-.11,0-.29-.08h0v-.06a24,24,0,0,0-1-4.76,38.55,38.55,0,0,0-2.19-4.66A10,10,0,0,1,261,209.7a12.09,12.09,0,0,1,.65,4.93l0-.07C261.76,214.68,261.82,214.75,261.81,214.78Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.09,176.15c1.24-3.55,2.07-7.49.8-11-.51-1.43-1.56-2.88-3.07-3a3.66,3.66,0,0,0-3.24,1.83,18.72,18.72,0,0,0-1.58,3.57,32.71,32.71,0,0,1-5,7.7c-3.29,4.17-4.18,13.1-18.48,15.2V211.2c6.67-1.53,14.59-.45,21.42-.49,1.94,0,4.07-.18,5.47-1.52a6.64,6.64,0,0,0,1.7-4.19c.63-6-2-12.07-1.34-18.1C344.18,183.17,345.84,179.7,347.09,176.15Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.34,184.34l-4.53,2.45s-13.57-.19-14,3.35v1.37h0a2.3,2.3,0,0,0-1.67,4.08,1.17,1.17,0,0,0,.4.25c.3,0-.47,1.87.91,2.85s5.41,1.38,5.41,1.38a5.27,5.27,0,0,0,.19,3c.59,1.08,5.12,2.16,6.79,1.87a38.58,38.58,0,0,0,5.11-1.68l8.56-2,2.16-13.18Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.69,191a8.65,8.65,0,0,1-2.36.79,27.16,27.16,0,0,1-6,.78,27.74,27.74,0,0,1-6-.52,9.17,9.17,0,0,1-2.39-.69,58,58,0,0,0,8.37.69A59.51,59.51,0,0,0,342.69,191Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.36,196.51a10.7,10.7,0,0,1-2.47.18c-1.52,0-3.63,0-5.95-.05s-4.43-.26-5.95-.42a11.25,11.25,0,0,1-2.44-.38,12.6,12.6,0,0,1,2.47,0l5.94.26,5.94.21A11.39,11.39,0,0,1,341.36,196.51Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.23,200.85a18.69,18.69,0,0,1-11.72-.85c.05-.16,2.59.63,5.83.85S342.2,200.69,342.23,200.85Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,268.35a5.31,5.31,0,0,1-1.76-5.88,7.24,7.24,0,0,1,1.62-8.78,6.46,6.46,0,0,1,6.79-8.75,5.39,5.39,0,0,1,9.73-3.17,5.18,5.18,0,0,1,9.59,3.79L45,268.38A5.3,5.3,0,0,1,38.9,268.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.71,244.94a22,22,0,0,0-23.52,18.34L42,264.4c-1.3,12.23,8.37,20.16,20.64,21.12l40.63,4.9,5.35-.82,29.89-15.93-22.47-9.6L105.19,262s.11-11.95-11.52-14C88.06,246.94,76.34,245.82,65.71,244.94Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.2,262a28.54,28.54,0,0,1-7,14.41s9-2.18,9.88-13.86Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.94,250.09A1.69,1.69,0,0,1,77.35,252a1.61,1.61,0,0,1-1.78,1.47,1.68,1.68,0,0,1-1.41-1.88A1.62,1.62,0,0,1,75.94,250.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.61,248.35c.18.24-1,1.35-1.25,3.14s.39,3.25.14,3.41-.47-.2-.79-.84a4.62,4.62,0,0,1-.38-2.77,4.5,4.5,0,0,1,1.26-2.46C71.11,248.35,71.53,248.23,71.61,248.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.18,265.56a1.68,1.68,0,0,1,1.41,1.88,1.6,1.6,0,0,1-1.78,1.46A1.68,1.68,0,0,1,72.39,267,1.61,1.61,0,0,1,74.18,265.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.54,265.43c.18.24-1,1.35-1.25,3.14s.39,3.25.14,3.41-.47-.2-.8-.84a4.63,4.63,0,0,1-.37-2.77,4.43,4.43,0,0,1,1.26-2.46C68,265.44,68.46,265.31,68.54,265.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.77,261.72a12.12,12.12,0,0,1,0-3c0-.46,0-.91-.29-1a2.42,2.42,0,0,0-1.41.08l-3.7.78c-5.26,1.06-9.56,1.74-9.6,1.53s4.19-1.24,9.45-2.3l3.72-.72a2.76,2.76,0,0,1,1.83.06,1.21,1.21,0,0,1,.55.86,2.93,2.93,0,0,1,0,.8A11.28,11.28,0,0,1,82.77,261.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.14,267.19c0-.29,2,0,3.63-1.41s1.78-3.54,2-3.51.3.53.18,1.41a4.88,4.88,0,0,1-1.6,2.94,4.22,4.22,0,0,1-3,1.06C83.55,267.62,83.11,267.33,83.14,267.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.43,264.56c.43.29-.24,1.77-.52,3.64s-.15,3.51-.64,3.62c-.24.05-.61-.33-.89-1.06a5.61,5.61,0,0,1-.28-2.9,5.49,5.49,0,0,1,1.16-2.63C62.75,264.66,63.22,264.43,63.43,264.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.64,248c.38.35-.15,1.56-.29,3.05s.05,2.79-.4,3.05c-.22.11-.62-.12-1-.71a4.31,4.31,0,0,1-.47-2.54,4.24,4.24,0,0,1,1-2.38C66,247.93,66.45,247.79,66.64,248Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.19,245.18s-7.8,1.87-10.08,5.1c-2.77,3.92,1.6,6.52-.2,10.39s-4.45,7.61-2,12.28c2.69,5.1,5.44,3.37,10.57,4.5,20.76,4.6,26.05,9.4,16,8.86-1.1-.06-2.45,2.8-7.09,2.49-6-.4-13.25-1.36-17.23-3.37-3.36-1.7-5.48-4.13-7.58-8.19-3.32-6.42-2.11-14.29-.69-19.54S51.14,243.19,60.19,245.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.29,285.52a3.2,3.2,0,0,0-3.61,2.91c-.15,2.2.68,4.82,5.19,5.42,8,1.06,7.42-7.2,7.19-7.24S77.64,285.93,74.29,285.52Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.82,288s.08.16.16.41a1.43,1.43,0,0,1-.12,1c-.42.81-1.86,1.34-3.31,1.19a4.61,4.61,0,0,1-1.94-.66,1.62,1.62,0,0,1-.93-1.19.72.72,0,0,1,.49-.77c.24-.08.39,0,.41-.05s-.11-.19-.45-.16a.89.89,0,0,0-.54.24,1.07,1.07,0,0,0-.31.75,2,2,0,0,0,1,1.62,4.82,4.82,0,0,0,2.16.78c1.62.16,3.24-.47,3.73-1.58a1.53,1.53,0,0,0,0-1.3C80,288,79.84,287.93,79.82,288Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.89,282.82A7.63,7.63,0,0,0,61,279.7a2.62,2.62,0,0,0-1.35-3.18c-.54-.19-1.2-.16-1.57-.59s-.15-1.3,0-1.95a5.15,5.15,0,0,0-2.77-5.88,2.16,2.16,0,0,0,.74-2.82,11.41,11.41,0,0,0-2-2.55,3.32,3.32,0,0,1-.92-3c.18-.57.63-1.06.67-1.66C54,257,52.81,256.33,51.8,256s-2.2-.65-2.62-1.63.09-1.92.39-2.86.28-2.22-.62-2.62a1.92,1.92,0,0,0-1.5.12,5.23,5.23,0,0,0-3,5.76A7.08,7.08,0,0,0,41,267.39a7.2,7.2,0,0,0,.71,11.77,5.21,5.21,0,0,0,6.52,7,5,5,0,0,0,3.45,3.32c1.64.31,3.55-1,3.38-2.69a2.89,2.89,0,0,0,3.65-4.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,287.4a2,2,0,0,0,1.62-.24,2.61,2.61,0,0,0,1.21-1.44,2.77,2.77,0,0,0-.29-2.38l-.1.33a8.32,8.32,0,0,0,2.25-1.26,4.75,4.75,0,0,0,1.14-1.31,3.59,3.59,0,0,0-.53-4.09,4.83,4.83,0,0,0-1.55-.92c-.39-.14-.62-.19-.63-.16s.19.13.56.33a5.35,5.35,0,0,1,1.39,1,3.29,3.29,0,0,1-.68,4.81,7.88,7.88,0,0,1-2.11,1.2l-.26.11.16.22a2.46,2.46,0,0,1,.29,2,2.39,2.39,0,0,1-1,1.32A3.83,3.83,0,0,1,55,287.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.26,269.36s.09-.2.3-.53a2.78,2.78,0,0,1,1.26-1.07l.16-.07-.13-.13a10.14,10.14,0,0,1-2.48-4.36A8,8,0,0,1,38.2,260,6.65,6.65,0,0,1,42,255a5.47,5.47,0,0,1,2.54-.48l.26,0,0-.25a4.52,4.52,0,0,1,1-3.25,4.47,4.47,0,0,1,2.24-1.49,5.9,5.9,0,0,1,2.44-.1,1.74,1.74,0,0,0-.64-.21,4.47,4.47,0,0,0-1.87.06,4.61,4.61,0,0,0-2.45,1.52,4.88,4.88,0,0,0-1.1,3.51l.23-.24a5.75,5.75,0,0,0-2.76.5,7,7,0,0,0-4,5.25A8.06,8.06,0,0,0,38,263.3a9.76,9.76,0,0,0,2.7,4.44l0-.21a2.73,2.73,0,0,0-1.27,1.23C39.26,269.13,39.24,269.35,39.26,269.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.13,267.39s44-2,54,2.25a88.06,88.06,0,0,0,18.07,5.57l68.1,4L425.65,296s-60.49,7.41-71.33,6-22.09-5.61-28.06-4.8-41.4,3.06-41.4,3.06Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,265s-12.34-1.22-22.62-1.29c-24.67-.17-53.42-4.31-53.42-4.31l-7.07,42,85.54-1.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,271.14c1.82-3.14,3.32-6.73,2.76-10.31-.23-1.45-1-3-2.37-3.44a3.55,3.55,0,0,0-3.4,1.15,18.75,18.75,0,0,0-2.14,3.1,31.44,31.44,0,0,1-6.13,6.39c-3.88,3.36-6.33,11.66-20.27,11.07l-2.49,17.31c6.9-.71,13.29,3.62,19.12,5.83a6.21,6.21,0,0,0,5.46-.45,6.36,6.36,0,0,0,2.37-3.67c1.68-5.6.27-11.8,2-17.39C451.93,277.26,454.13,274.28,456,271.14Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.59,265a4.46,4.46,0,0,1-.68,0l-2-.06-7.17-.32-23.64-1.23L249.52,262l-7.16-.49-2-.15a3,3,0,0,1-.67-.09,2.71,2.71,0,0,1,.68,0l2,.06,7.17.32,23.64,1.24,23.63,1.39,7.16.48,1.94.15A3.35,3.35,0,0,1,306.59,265Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.83,264.44s20.39-9.38,33.86-10c9.45-.41,67.31,2.6,67.31,2.6s8.4-1.43,11.84-.09a17.31,17.31,0,0,0,5.6,1.33l-4.52,42.46-97-1.24-19.16-.39a8.9,8.9,0,0,1-7.29-4.18h0a21,21,0,0,1-1.58-20C104,270.32,107.65,267.23,112.83,264.44Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.56,267.23a16,16,0,0,0-15.26,3.3,17.45,17.45,0,0,0-5.83,10.18c-1.7,10.47,3.82,14.15,7.07,15.71s18,1.7,18,1.7,36.22,11,45.27,8.91,10.47-19,10.47-19l-2.83-31.83h-15a40.55,40.55,0,0,1-2,14,103.37,103.37,0,0,1-5.52,12.6l-17.69-8.35A97.45,97.45,0,0,0,122.56,267.23Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.06,254.06s-.37-4.92,2.76-5.82c0,0,2.9-1.56,4-2a18.54,18.54,0,0,1,2.38-.74l6.26-1.79s.45-2.54,2.61-3.13,3.23,1.64,3.23,1.64l1.09,3.8s1.27-1.64,2.76-.82,2.54,2.9,2.09,3.35-1.34,1.57-1.34,1.57l1.11,2.38s-1.86,2.53-2.45,2.76-4.08,1.84-4.08,1.84l-15.37-.43S159.73,255.55,159.06,254.06Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.86,245a1.88,1.88,0,0,0-.39-1.85c-.76-1-1.62-1.7-2.73-1.41s-5.5,3.16-2.9,4.53,3.86,0,4.57-.28A6.49,6.49,0,0,0,182.86,245Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.86,245s-.14.23-.51.54a4.73,4.73,0,0,1-.71.5c-.31.15-.59.36-1,.58a3.52,3.52,0,0,1-1.37.45,3.92,3.92,0,0,1-1.64-.2,3.39,3.39,0,0,1-1.61-.95,1.41,1.41,0,0,1-.24-.51,1.74,1.74,0,0,1,0-.56,2.54,2.54,0,0,1,.48-.94,8.22,8.22,0,0,1,3-2.23,2.15,2.15,0,0,1,1.7-.1,3.26,3.26,0,0,1,1.17.87,3.08,3.08,0,0,1,.92,1.82c0,.5-.16.75-.19.73a4.79,4.79,0,0,0,0-.71,3,3,0,0,0-1-1.59,2.87,2.87,0,0,0-1.05-.71,1.68,1.68,0,0,0-1.36.12,8.63,8.63,0,0,0-2.74,2.11c-.35.47-.59,1-.26,1.4a3.14,3.14,0,0,0,1.35.8,3.3,3.3,0,0,0,2.69-.12c.36-.18.71-.4,1-.52a5.2,5.2,0,0,0,.73-.4C182.63,245.14,182.84,245,182.86,245Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.06,242.21a3.13,3.13,0,0,0-2.7-1.74c-1.87,0-5.41,1.17-5.54,2.7s.4,2,1.15,2.09,6.56-1.77,6.56-1.77Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.06,242.21a5.21,5.21,0,0,1-.41,1.33l0,.05-.06,0c-.82.3-2,.72-3.52,1.17-.75.22-1.55.46-2.44.66a2.28,2.28,0,0,1-.76.06,1.49,1.49,0,0,1-.76-.32,2,2,0,0,1-.55-1.5,3.69,3.69,0,0,1,0-.57,1.53,1.53,0,0,1,.21-.6,3,3,0,0,1,.79-.8,7.06,7.06,0,0,1,1.81-.89,8.48,8.48,0,0,1,3.34-.52,3,3,0,0,1,2,1.17c.33.43.41.72.38.74s-.17-.24-.53-.61a2.9,2.9,0,0,0-1.85-.93,8.68,8.68,0,0,0-3.14.6,7.31,7.31,0,0,0-1.67.85,2.54,2.54,0,0,0-.65.66,1,1,0,0,0-.13.39,4.07,4.07,0,0,0,0,.5,1.52,1.52,0,0,0,.37,1.12,1,1,0,0,0,.5.21,2.08,2.08,0,0,0,.58-.06c.85-.17,1.67-.39,2.41-.59l3.57-1-.08.07A7.06,7.06,0,0,1,175.06,242.21Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.92,250.11s.61-1.47,1.44-1.33,2.17,2.24,2.17,2.7-2.55,2-2.66,1.23A14.1,14.1,0,0,0,184.92,250.11Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.92,250.11a4.61,4.61,0,0,1,.83,1.51,8,8,0,0,1,.3.84c0,.06,0,.21,0,.22s0,0,0,0a.79.79,0,0,0,.36-.06,4.72,4.72,0,0,0,1.76-1.12s0-.06,0,0,0,0,0,0a1.86,1.86,0,0,0-.09-.24c-.08-.16-.16-.32-.25-.48a8.47,8.47,0,0,0-.6-.88c-.42-.51-.89-1-1.27-.84a2,2,0,0,0-.84.76c-.17.23-.26.37-.29.36s0-.19.12-.46a2,2,0,0,1,.88-1,1,1,0,0,1,1,.16,4.33,4.33,0,0,1,.77.72,6.56,6.56,0,0,1,.66.92,3.81,3.81,0,0,1,.29.53,1.52,1.52,0,0,1,.12.32.53.53,0,0,1,0,.26.7.7,0,0,1-.11.23,3.64,3.64,0,0,1-1,.81,4.73,4.73,0,0,1-1,.48,1.2,1.2,0,0,1-.64,0,.45.45,0,0,1-.31-.32,1.93,1.93,0,0,1,0-.24c-.06-.29-.15-.56-.22-.81A7.35,7.35,0,0,1,184.92,250.11Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.85,293s-.56-.35-1.15-1.2a8.1,8.1,0,0,1-1.33-3.77,8.24,8.24,0,0,1,.57-4c.41-.95.84-1.43.89-1.39a13.57,13.57,0,0,1-.55,1.52,9.75,9.75,0,0,0-.4,3.79A9.41,9.41,0,0,0,157,291.6,13.09,13.09,0,0,1,157.85,293Z",
    style: {
      fill: "#6f4439"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhisiotherapyPana);
export default __webpack_public_path__ + "static/media/Phisiotherapy-pana.c08b4949288fee9fd86919b0fa6f4bc5.svg";
export { ForwardRef as ReactComponent };